import * as R from 'ramda';
import moment from 'moment';

export default function MarkAgendaItemCompleteConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  oversightDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.appLoaded = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleMarkItemCompleteFormSubmit = _handleMarkItemCompleteFormSubmit;
  vm.handleAssignmentChange = handleAssignmentChange;

  if (vm.item.completedDate) {
    vm.lastCompletedDate = vm.item.completedDate;
  }

  vm.completedDate = Date.now();
  //  _activate();

  // //////// METHODS //////////

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.oversight.markAgendItemCompleteConfirmDialog);
  }

  function _handleMarkItemCompleteFormSubmit() {
    const dfdRefresh = $q.defer();

    if ($scope.markCompleteForm.$invalid) {
      return dfdRefresh.resolve();
    }

    if (!_isValid()) {
      // Set the form as unsubmitted since the user needs to make changes
      $scope.markCompleteForm.$setPristine();
      $scope.markCompleteForm.$setUntouched();
      return dfdRefresh.resolve();
    }

    if (!R.isNil(vm.completedDate)) {
      vm.item.completedDate = moment(vm.completedDate).format('MM/DD/YYYY');
      vm.item.agendaItemStatusId = 3;
    } else {
      vm.item.completedDate = null;
    }

    if (!R.isNil(vm.nextDueDate)) {
      vm.item.nextDueDate = moment(vm.nextDueDate).format('MM/DD/YYYY');
    } else {
      vm.item.nextDueDate = null;
    }
    loaderService.showViewLoader = true;
    oversightDataService.completeAgendaItem(vm.item.agendaItemId, vm.item).then((response) => {
      const savedAgendaItem = response.data;
      loaderService.showViewLoader = false;
      if (savedAgendaItem.agendaItemId === 'undefined' || savedAgendaItem.agendaItemId <= 0) {
        // There was an error saving the agenda information
        alerts.error('An error occurred while completing the agenda.');
        dfdRefresh.reject();
      } else {
        // The agenda information has been saved
        vm.item = savedAgendaItem;
        alerts.success('The Agenda Item has been successfully completed.');
        ssDialogService.hide(ssDialogService.dialogs.oversight.markAgendItemCompleteConfirmDialog)
          .then(dfdRefresh.resolve);
        $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.item.agendaItemId });
      }
    });

    return dfdRefresh.promise;
  }

  /**
   * Sync statusId and assignedToUser to assignedToUserId
   */
  function handleAssignmentChange() {
    vm.item.nextAssignedToUserId = vm.nextAssignedToUser.userId;
    if (vm.item.agendaItemStatusId !== 3) { // Completed
      if (vm.item.assignedToUserId > 0) {
        vm.item.agendaItemStatusId = 2; // Assigned
      } else {
        vm.item.agendaItemStatusId = 1; // Unassigned
      }
    }
  }

  function _isValid() {
    let isValid = true;
    /* isValid = _areDatesValid();
    angular.forEach($scope.editAMFindingForm.$error.pattern, () => {
      isValid = false;
    });
    angular.forEach($scope.editAMFindingForm.$error.required, () => {
      isValid = false;
    });
    if (!isValid) {
      alerts.error('There were errors saving the Finding.');
    } */
    // Add conditional errors test
    if (isValid) {
      if (!_hasBothAssignedUserAndDueDateOrNeither()) {
        alerts.error('If the Due Date or Assigned User is entered, then both must be set in the Agenda Item.');
        isValid = false;
      }
    }
    return isValid;
  }

  function _hasBothAssignedUserAndDueDateOrNeither() {
    // Is assigned to user
    const a = vm.item.nextAssignedToUserId && vm.item.nextAssignedToUserId > -1;
    // Has a due date
    const b = !!vm.nextDueDate;

    if (a || b) return a && b; // has both?
    return true; // has neither
  }
}

MarkAgendaItemCompleteConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'oversightDataService',
  'loaderService',
  'ssDialogService'
];
